<div class="px-4">
    <div class="text-center text-gray-500 py-4">
        <h4>Agenda Veículo</h4>
    </div>
    <div [formGroup]="form" class="mt-4 mx-auto">
        <div class="flex flex-row justify-between items-center w-full">
            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Placa</mat-label>
                <input matInput formControlName="plate" readonly />
            </mat-form-field>
            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Tipo Veículo</mat-label>
                <input matInput formControlName="typeVehicle" readonly />
            </mat-form-field>

            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Modelo</mat-label>
                <input matInput formControlName="model" readonly />
            </mat-form-field>
        </div>

        <div class="flex flex-row justify-end items-center w-full">
            <div class="flex flex-row justify-end w-auto gap-3 mb-6 mr-2">
                <button mat-flat-button class="btn-tg w-5/12" (click)="cancel()">
                    Cancel
                </button>
                <!-- @if(view){ -->
                <button *ngIf="editIndex === null" mat-flat-button class="btn-tg px-6 w-5/12" (click)="next()"
                    [disabled]="loading">
                    @if(loading){
                    <mat-spinner *ngIf="loading" diameter="22" class="loading-spinner"
                        selected-track-color="red"></mat-spinner>
                    }@else{
                    Próximo
                    }
                </button>
                <!-- }@else{
                <button *ngIf="editIndex === null" mat-flat-button class="btn-tg px-6 w-5/12" (click)="addItemToList()"
                    [disabled]="!selectionActive">
                    @if(loading){
                    <mat-spinner *ngIf="loading" diameter="22" class="loading-spinner"
                        selected-track-color="red"></mat-spinner>
                    }@else{
                    Próximo
                    }
                </button>
                } -->

            </div>
        </div>

        <div class="flex flex-row justify-start items-center w-full" *ngIf="!view">
            <mat-form-field class="input-tg w-1/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Tipo Pesquisa</mat-label>
                <mat-select formControlName="typeSearch">
                    <mat-option MatDatepicker *ngFor="let type of listSearch" [value]="type.value">
                        {{type.description}}
                    </mat-option>
                </mat-select>


            </mat-form-field>
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Pesquisa</mat-label>
                <input matInput formControlName="search" />
            </mat-form-field>

            <div class="flex justify-center items-center mb-4 gap-2">
                <button class="btn-icon" (click)="resetForm()"
                    [matTooltip]="'Limpar Pesquisar'"><mat-icon>replay</mat-icon></button>
                <button class="btn-icon" (click)="searchItem()"
                    [matTooltip]="'Pesquisa'"><mat-icon>search</mat-icon></button>
            </div>
        </div>
    </div>

    @if(!loading){


    <div class="mt-4">
        <!-- @if (checkPermission('pesquisar-paginado')) {
      <form-search [search]="inputSearch" (responseSearch)="search($event)" />
    } -->
        <!-- <div>
                @if (!loading) {
                <div *ngIf="itemsList.length > 0; else noItems">


                    <table-list-simple [dataSource]="itemsList" [columns]="columns" (selectItem)="editItem($event)"
                        (deleteItem)="deleteItem($event)" />


                </div>
                <ng-template #noItems>
                    <div class="text-center text-gray-500 py-4">
                        Nenhum item encontrado.
                    </div>
                </ng-template>
                } @else {
                <div>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                }
            </div> -->
        @if (itemsList != null && itemsList.length > 0) {
        <div>
            @if(!loading){
            <div class="tab-overflow">
                <table mat-table [dataSource]="itemsList" class="mat-elevation-z8">
                    @for (column of columns; track column.keyColumn) {
                    <ng-container matColumnDef="{{ column.keyColumn }}">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ column.description }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (column.keyColumn === 'select') {
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="onSelectRow(element, $event.checked)"
                                [checked]="selection.isSelected(element)" [disabled]="dataVehicle.viewMode">
                            </mat-checkbox>
                            }
                            @if (column.keyColumn == 'action' && dataVehicle.viewMode) {
                            <div class="flex justify-center items-center gap-3">
                                @if (column.key.edit) {
                                <mat-icon class="btn-icon-outline" fontIcon="edit" (click)="editItem(element)" />
                                }
                                @if (column.key.delete) {
                                <mat-icon class="btn-icon-outline" fontIcon="delete" (click)="deleteItem(element)" />
                                }
                            </div>
                            } @else {
                            {{ element[column.key] }}
                            }
                        </td>
                    </ng-container>
                    }
                    <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row class="style-row" *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
            }@else {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
            <mat-paginator #paginator [pageSize]="this.rows"></mat-paginator>
        </div>
        }@else {
        <div class="text-center text-gray-500 py-4">
            Nenhum item encontrado.
        </div>
        }
    </div>
    }@else {
    <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    }


</div>